var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F2F4F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#F9FAFB",
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_257_4212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3326 26.3333L22.9992 23M22.9992 23L19.6659 26.3333M22.9992 23V30.5M29.9909 28.325C30.8037 27.8819 31.4458 27.1807 31.8158 26.3322C32.1858 25.4836 32.2627 24.536 32.0344 23.6389C31.8061 22.7418 31.2855 21.9463 30.5548 21.3779C29.8241 20.8095 28.925 20.5006 27.9992 20.5H26.9492C26.697 19.5244 26.2269 18.6186 25.5742 17.8508C24.9215 17.083 24.1033 16.4732 23.181 16.0672C22.2587 15.6611 21.2564 15.4695 20.2493 15.5066C19.2423 15.5437 18.2568 15.8086 17.3669 16.2814C16.477 16.7542 15.7058 17.4226 15.1114 18.2363C14.517 19.05 14.1148 19.9879 13.9351 20.9795C13.7553 21.971 13.8027 22.9904 14.0736 23.961C14.3445 24.9317 14.8319 25.8282 15.4992 26.5833",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_257_4212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.17847a3f4e7ea5ee5d5e5edb0dd49ac7.svg";
export { ForwardRef as ReactComponent };